var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m250.004 91.601-22.407-24.567C175.002 9.368 78.562 29.268 43.748 101.768c-16.344 34.1-20.032 83.333 9.813 146.166 28.751 60.5 88.565 132.966 196.443 211.899 107.878-78.933 167.661-151.4 196.443-211.899 29.845-62.866 26.188-112.066 9.813-146.166-34.814-72.5-131.254-92.433-183.849-34.767l-22.407 24.6zm0 408.399c-479.171-337.732-147.536-601.331-5.5-461.898 1.875 1.833 3.719 3.733 5.5 5.7 1.763-1.965 3.598-3.855 5.5-5.667 142.005-139.533 473.671 124.099-5.5 461.865z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a45c5906722e21fbdffc11d514fd05f9.svg";
export { ForwardRef as ReactComponent };